import { instance } from './api';

export async function getPlantDetailsByQRapi(payload) {
  return instance.get(`/user/plantDetails/${payload}`).then((res) => res.data);
}
